import * as Yup from "yup"

export const FIELDS_NAME = {
   TEXT_AREA_VALUE: "textAreaValue",
   IS_CHECKED: "isChecked",
}

export const initialValues = {
   [FIELDS_NAME.TEXT_AREA_VALUE]: "",
   [FIELDS_NAME.IS_CHECKED]: false,
}

export const validationSchema = Yup.object({
   [FIELDS_NAME.TEXT_AREA_VALUE]: Yup.string()
      .trim()
      .required("Note text is required")
      .max(1000, "Note text cannot exceed 1000 characters"),
})
